import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["dir"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TimeCore = _resolveComponent("TimeCore")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("div", { dir: _ctx.dir }, [
    (_ctx.generalMethods.valueExist(_ctx.prop))
      ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          label: _ctx.hideLabel ? null : _ctx.generalMethods.translate(_ctx.label),
          for: _ctx.id == null ? _ctx.prop : _ctx.id,
          prop: _ctx.prop,
          rules: _ctx.rules,
          class: _normalizeClass(`${_ctx.elFormItemClassses}`),
          required: _ctx.required
        }, _createSlots({
          default: _withCtx(() => [
            _createVNode(_component_TimeCore, {
              id: _ctx.id == null ? _ctx.prop : _ctx.id,
              modelValue: _ctx.localModelValue,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localModelValue) = $event)),
              dir: _ctx.dir,
              onChange: _cache[1] || (_cache[1] = (value) => _ctx.emitEvent('change', value)),
              label: _ctx.ariaLabel,
              disabled: _ctx.disabled,
              readonly: _ctx.readonly,
              placeholder: _ctx.placeholder,
              size: _ctx.size,
              autofocus: _ctx.autofocus,
              disabledDates: _ctx.disabledDates
            }, null, 8, ["id", "modelValue", "dir", "label", "disabled", "readonly", "placeholder", "size", "autofocus", "disabledDates"])
          ]),
          _: 2
        }, [
          (!_ctx.hideLabel)
            ? {
                name: "label",
                fn: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "label")
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["label", "for", "prop", "rules", "class", "required"]))
      : (_openBlock(), _createBlock(_component_TimeCore, {
          key: 1,
          id: _ctx.id == null ? _ctx.prop : _ctx.id,
          modelValue: _ctx.localModelValue,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localModelValue) = $event)),
          dir: _ctx.dir,
          onChange: _cache[3] || (_cache[3] = (value) => _ctx.emitEvent('change', value)),
          label: _ctx.ariaLabel,
          disabled: _ctx.disabled,
          readonly: _ctx.readonly,
          placeholder: _ctx.placeholder,
          size: _ctx.size,
          autofocus: _ctx.autofocus,
          disabledDates: _ctx.disabledDates
        }, null, 8, ["id", "modelValue", "dir", "label", "disabled", "readonly", "placeholder", "size", "autofocus", "disabledDates"]))
  ], 8, _hoisted_1))
}